import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';
import fbfsCookie from '../utils/cookie';

class LearningCenterSelector {
    constructor() {
    }

    init() {
        this.bindEvents();
        this.cardArrowHandler();
    }

    cardArrowHandler() {
        $(document).on('click', '.learning-center-category-selector .learning-center-category', () => {
            let selector = $('.learning-center-category-selector .learning-center-category');
            if (selector.hasClass('active'))
            {
                selector.addClass('inactive');
                selector.removeClass('active');
            }
            else
            {
                selector.removeClass('inactive');
                selector.addClass('active');
            }
        });
    }

    cleanToAlphabeticalWithSpaces(text) {
        //Remove non-alphabet characters
        const removeNonAlphaRegex = new RegExp('[^a-zA-Z]', 'g');
        let result = text.replace(removeNonAlphaRegex, '');

        //Add spaces before capital letters
        const addSpacesRegex = new RegExp('([A-Z])', 'g');
        result = result.replace(addSpacesRegex, ' $1');

        //Trim the result in case the original string starts with a capital letter
        return result.trim();
    }

    setLastLCArticleVisitedAsFirst(articleCookie) {
        //Save callback
        const formatText = this.cleanToAlphabeticalWithSpaces;
        //Format cookie
        let spacedAndFormattedCookie = formatText(articleCookie);
        let position = 0;
        //Iterate
        $('.learning-center-category').each((index, item) => {
            let { ariaLabel } = item;
            //Fix to make it formattable
            if (ariaLabel != null && ariaLabel.includes('Estate and'))
				{
					ariaLabel = 'Estate And Tax Planning';
				}
            let formattedLabel = formatText(ariaLabel);
            //If formatted cookie and aria-label match, assign index of learning-center-category
            if (formattedLabel === spacedAndFormattedCookie) {
                position = index;
            }
        });
        return position;
    }

    bindEvents() {
        let articleCookie = fbfsCookie.getCookie('VisitedLCArticleCategory');
        let firstCategory = '';
        if (articleCookie !== '') {
            firstCategory = $('.learning-center-category').eq(this.setLastLCArticleVisitedAsFirst(articleCookie));
        } else {
            firstCategory = $('.learning-center-category').first();
        }
        let activeCategory = $(firstCategory).data('category');
        firstCategory.attr('aria-selected', 'true');
        firstCategory.attr('tabindex', '0');
        $(`.learning-center-category:not([data-category="${activeCategory}"])`).attr('aria-selected', 'false');
        $(`.learning-center-category:not([data-category="${activeCategory}"])`).attr('tabindex', '-1');

        // Set active class on first category on load
        $('.learning-center-article-wrapper').find(`[data-article-category="${activeCategory}"]`).addClass('active');
        $('.learning-center-category-selector .learning-center-category').addClass('active');

		if (Util.getViewPort() === CONST.ViewPort.Mobile) {
            firstCategory.clone().addClass('active').appendTo($('.learning-center-category-selector'));

            $('.learning-center-category-selector').on('click', (e) => {
                $('.learning-center-category-list').slideToggle();
                firstCategory.removeClass('active');
                firstCategory.removeClass('selected');
                firstCategory.attr('aria-selected', 'false');
                firstCategory.attr('tabindex', '-1');
            });

            $('.learning-center-category:not(".active")').on('click', (e) => {
                let category = $(e.currentTarget);
                let categoryName = $(category).data('category');
                let categoryId = $(category).attr('id');
                let categoryAriaControls = $(category).attr('aria-controls');

                $('.learning-center-article-wrapper').attr('aria-labelledby', `${categoryId}`);
                $('.learning-center-article-wrapper').attr('id', `${categoryAriaControls}`);

                $(`.learning-center-category[data-category="${categoryName}"]`).attr('aria-selected', 'true');
                $(`.learning-center-category[data-category="${categoryName}"]`).attr('tabindex', '0');
                $(`.learning-center-category:not([data-category="${categoryName}"])`).attr('aria-selected', 'false');
                $(`.learning-center-category:not([data-category="${categoryName}"])`).attr('tabindex', '-1');


                $('.learning-center-category-select').html('');
                $('.learning-center-article').removeClass('active');

                $('.learning-center-category-list').slideToggle(100);
                $(`.learning-center-article[data-article-category="${categoryName}"]`).addClass('active'); 

                $('.learning-center-category-selector').html($(category).clone().addClass('active'));    
                
                $('.learning-center-category.selected').removeClass('selected');
                $(e.currentTarget).addClass('selected');
            });
		} else {
            // tablet and desktop
            firstCategory.addClass('active');
            firstCategory.addClass('selected');
            firstCategory.attr('aria-selected', 'true');
            firstCategory.attr('tabindex', '0');
            
            // User click
            $('.learning-center-category').on('click', (e) => {
                let category = $(e.currentTarget);
                let categoryName = $(category).data('category');
                let categoryId = $(category).attr('id');
                let categoryAriaControls = $(category).attr('aria-controls');
                let articleWrappers = $('.learning-center-article-wrapper [id^="item-article-"]');
                let date = new Date();
                date.setDate(date.getDate() + 21);
                document.cookie = `VisitedLCArticleCategory=${$(e.currentTarget).text().replace(/[^a-zA-Z]+/g, '')};expires=${date.toGMTString()};`;

                $('.learning-center-category').removeClass('active');
                $('.learning-center-category').removeClass('selected');
                $('.learning-center-article').removeClass('active');
                $('.learning-center-article').removeClass('selected');
                $('.learning-center-article-wrapper').attr('aria-labelledby', `${categoryId}`);
                $('.learning-center-article-wrapper').attr('id', `${categoryAriaControls}`);
                
                category.addClass('active');
                category.addClass('selected');
                $(`.learning-center-article[data-article-category="${categoryName}"]`).addClass('active');
                $(`.learning-center-article[data-article-category="${categoryName}"]`).addClass('selected');  

                category.attr('aria-selected', 'true');
                category.attr('tabindex', '0');
                $(`.learning-center-category:not([data-category="${categoryName}"])`).attr('aria-selected', 'false');
                $(`.learning-center-category:not([data-category="${categoryName}"])`).attr('tabindex', '-1');  
            });
            
            // User moving through category list using arrow keys 
            $('.learning-center-category').on('keyup', (e) => {
                let category = $(e.currentTarget);
                let categoryName = $(category).data('category');
                $('.learning-center-category').removeClass('active');
                $('.learning-center-category').removeClass('selected');
                $('.learning-center-article').removeClass('active');   
                $('.learning-center-article').removeClass('selected');
                
                const [prefix, numericStr] = categoryName.split('-');
                let numberOptions =  $('.learning-center-category').length;
                let position = parseInt(numericStr, 10);

                // Down arrow key
                if (e.keyCode === 40 && numberOptions >= 2) {
                    if (position === numberOptions - 1) {
                        position = 0;
                    } else {
                        position += 1;
                    }

                    let newCategory = $(`.learning-center-category[data-category="${prefix}-${position}"]`);
                    let allOtherEls = $(`.learning-center-category:not([data-category="${prefix}-${position}"])`);
                    $('.learning-center-article-wrapper').attr('aria-labelledby', `${prefix}-category-${position}`);
                    $('.learning-center-article-wrapper').attr('id', `tabpanel-${position}`);

                    newCategory.attr('aria-selected', 'true');
                    newCategory.attr('tabindex', '0');
                    newCategory.focus();

                    allOtherEls.attr('aria-selected', 'false');
                    allOtherEls.attr('tabindex', '-1'); 
                }
                
                // Up arrow key
                if (e.keyCode === 38 && numberOptions >= 2) {
                    if (position === 0) {
                        position = numberOptions - 1;
                    } else {
                        position -= 1;
                    }

                    let newCategory = $(`.learning-center-category[data-category="${prefix}-${position}"]`);
                    let allOtherEls = $(`.learning-center-category:not([data-category="${prefix}-${position}"])`);
                    $('.learning-center-article-wrapper').attr('aria-labelledby', `${prefix}-category-${position}`);
                    $('.learning-center-article-wrapper').attr('id', `tabpanel-${position}`);

                    newCategory.attr('aria-selected', 'true');
                    newCategory.attr('tabindex', '0');
                    newCategory.focus();

                    allOtherEls.attr('aria-selected', 'false');
                    allOtherEls.attr('tabindex', '-1'); 
                }

                // Enter key
                if (e.keyCode === 13) {
                    let newCategory = $(`.learning-center-category[data-category="${prefix}-${position}"]`);
                    $('.learning-center-article-wrapper').attr('aria-labelledby', `${prefix}-category-${position}`);
                    $('.learning-center-article-wrapper').attr('id', `tabpanel-${position}`);
                    
                    newCategory.addClass('active');
                    newCategory.addClass('selected');
                    newCategory.attr('aria-selected', 'true');
                    
                    $(`.learning-center-article[data-article-category="${prefix}-${position}"]`).addClass('active');
                    $(`.learning-center-article[data-article-category="${prefix}-${position}"]`).addClass('selected'); 
                }

                // Right arrow key
                if (e.keyCode === 39) {
                    let newCategory = $(`.learning-center-category[data-category="${prefix}-${position}"]`);
                    $('.learning-center-article-wrapper').attr('aria-labelledby', `${prefix}-category-${position}`);
                    $('.learning-center-article-wrapper').attr('id', `tabpanel-${position}`);

                    newCategory.addClass('active');
                    newCategory.addClass('selected');
                    newCategory.attr('aria-selected', 'true');
                    
                    $(`.learning-center-article[data-article-category="${prefix}-${position}"]`).addClass('active');
                    $(`.learning-center-article[data-article-category="${prefix}-${position}"]`).addClass('selected'); 
                    $(`.learning-center-article[data-article-category="${prefix}-${position}"] a`).first().focus();
                }
            });

             // User moving through article list using arrow keys 
            $('.learning-center-article').on('keyup', (e) => {
                let category = $(e.currentTarget);
                let categoryName = $(category).data('article-item');
                const [prefix, numericStr] = categoryName.split('-');
                let numberOptions =  $('.learning-center-article.active.selected').length;
                let position = parseInt(numericStr, 10);


                // Down arrow key
                if (e.keyCode === 40 && numberOptions >= 2) {
                    if (position === numberOptions - 1) {
                        position = 0;
                    } else {
                        position += 1;
                    }
                    
                    let newArticle = $(`.learning-center-article.active[data-article-item="${prefix}-${position}"]`);
                    let allOtherEls = $(`.learning-center-article.active:not([data-article-item="${prefix}-${position}"])`);
                    newArticle.attr('aria-selected', 'true');
                    newArticle.attr('tabindex', '0');
                    $(`.learning-center-article.active[data-article-item="${prefix}-${position}"] a`).first().focus();

                    allOtherEls.attr('aria-selected', 'false');
                    allOtherEls.attr('tabindex', '-1'); 
                }
                
                // Up arrow key
                if (e.keyCode === 38 && numberOptions >= 2) {
                    if (position === 0) {
                        position = numberOptions - 1;
                    } else {
                        position -= 1;
                    }
                    
                    let newArticle = $(`.learning-center-article.active[data-article-item="${prefix}-${position}"]`);
                    let allOtherEls = $(`.learning-center-article.active:not([data-article-item="${prefix}-${position}"])`);
                    newArticle.attr('aria-selected', 'true');
                    newArticle.attr('tabindex', '0');
                    $(`.learning-center-article.active[data-article-item="${prefix}-${position}"] a`).first().focus();

                    allOtherEls.attr('aria-selected', 'false');
                    allOtherEls.attr('tabindex', '-1'); 
                }

                // Left arrow key
                if (e.keyCode === 37) {
                    $('button.learning-center-category.active').focus();
                }
            });
		}
    }
}

export default LearningCenterSelector;

$(() => {
	const learningCenterSelector = new LearningCenterSelector();
	learningCenterSelector.init();
});